import {
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Stack,
    Typography
} from '@mui/material';
import React, { useState } from 'react';
import CustomDialog from '../../common/custom-dialog/custom-dialog';
import { Money } from '../../../utils/money';
import MoneyInput from '../../common/money-input/money-input';
import { OrderType } from '../../../interfaces/delivery-company/orders';
import { get_cod } from '../../../utils/cod';

interface UpdateCODProps {
    onSubmit: (m: Money[]) => void;
    onClose: () => void;
    order: OrderType;
    defaultCOD: Money[];
}

function UpdateCOD({ onSubmit, onClose, defaultCOD, order }: UpdateCODProps) {
    const [cod, setCOD] = useState<Money[]>(defaultCOD);

    const handleSubmit = () => {
        onSubmit(cod);
        onClose();
    };

    const handleReset = () => setCOD(get_cod(order));
    const handleDeliveryOnly = () => setCOD(order.delivery_fee);
    const handleFreeOfCharge = () => setCOD([]);
    const handleReturnFee = () => setCOD(order.merchant!.default_return_fee)

    return (
        <CustomDialog open={true} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>Return COD</DialogTitle>
            <DialogContent>
                <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 1 }}>
                    Suggested Actions
                </Typography>
                {/* Suggestion Buttons */}
                <Stack direction="row" spacing={1} flexWrap="wrap">
                    <Button
                        size="small"
                        variant="outlined"
                        onClick={handleReset}
                        sx={{ textTransform: 'none', borderRadius: 2 }}
                    >
                        Reset to Default
                    </Button>
                    <Button
                        size="small"
                        variant="outlined"
                        onClick={handleDeliveryOnly}
                        sx={{ textTransform: 'none', borderRadius: 2 }}
                    >
                        Delivery Charge
                    </Button>
                    <Button
                        size="small"
                        variant="outlined"
                        onClick={handleReturnFee}
                        sx={{ textTransform: 'none', borderRadius: 2 }}
                    >
                        Return Charge
                    </Button>
                    <Button
                        size="small"
                        variant="outlined"
                        onClick={handleFreeOfCharge}
                        sx={{ textTransform: 'none', borderRadius: 2 }}
                    >
                        Free of Charge
                    </Button>
                </Stack>

                <br />
                <MoneyInput money={cod} setMoney={setCOD} label="Return COD" />
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Cancel</Button>
                <Button variant="contained" onClick={handleSubmit}>Save</Button>
            </DialogActions>
        </CustomDialog>
    );
}

export default UpdateCOD;
